import React, { useState, Component } from 'react';
import { Link } from 'react-router-dom'



class NavButton extends Component {
  // use a constructor if necessary
  constructor(props) {
    super(props);
   
    this.state = {
      isHovered: false
    };

    // This binding is necessary to make `this` work in the callback
    this.handleHover = this.handleHover.bind(this);
  }

  handleHover = () => this.setState({ isHovered: !this.state.isHovered });
  
  // rotate-90 trans-origin-bot dib ta-center
  render() {
    const { width, height, cx, content, rotated, label, fullWidth, outerCx } = this.props;



    //1000px / 10 = 100px todo: calibrate button respons
    //todo: research best html tag for nav el's?
    return (
      
        <Link aria-label={label} to= {`${this.props.link}`} className={`w-100 pos-relative height-fit hover-animation flex justify-content-center items-center ${outerCx} ${fullWidth ? "h-5 tablet-h-12" : "nav-circle" } ${this.state.isHovered ? "bg-hover" : ""}`} onMouseEnter={this.handleHover} onMouseLeave={this.handleHover}  >
          <div className={`w-${width} h-${height} ${cx} inner-circle hover-animation ta-center`}> {content} </div>
        </Link>
      
      
    );
  }
}


export default NavButton;